const GeneralUtils = {
    formatDate: (date, format = 'DD/MM/YYYY hh:mm') => {
        if (date) {
            const dateObj = new Date(date);
            if (format === 'DD/MM/YYYY') {
                return dateObj.toLocaleDateString();
            }

            if (format === 'DD/MM/YYYY hh:mm:ss') {
                return dateObj.toLocaleDateString() +' '+ dateObj.toLocaleTimeString();
            }

            if (format === 'YYYY-MM-DD') {
                return dateObj.toJSON().split('T')[0];
            }
            if (format === 'hh:mm') {
                const hours = String(dateObj.getHours()).padStart(2, '0');
                const minutes = String(dateObj.getMinutes()).padStart(2, '0');

                return `${hours}:${minutes}`;
            }

            return dateObj.toLocaleDateString() + ' ' + dateObj.toLocaleTimeString([], {timeStyle: 'short'});
        }

        return null;
    },

    getTimeDiff: (startTime, endTime) => {
        if (!startTime || !endTime) return "";

        const [startH, startM] = startTime.split(':').map(Number);
        const [endH, endM] = endTime.split(':').map(Number);

        const startTotalMinutes = (startH * 60) + startM;
        let endTotalMinutes = (endH * 60) + endM;

        if (endTotalMinutes < startTotalMinutes) {
            endTotalMinutes += 24 * 60;
        }

        const diffMinutes = endTotalMinutes - startTotalMinutes;

        const diffH = String(Math.floor(diffMinutes / 60)).padStart(2, '0');
        const diffM = String(diffMinutes % 60).padStart(2, '0');

        return `${diffH}:${diffM}`;
    },

    formatDateFromAgGrid: (date) => {
        if (date) {
            if (typeof date === 'object' ) {
                return date.toLocaleDateString()
            }

            const dateSplit = date.split("-");
            return `${dateSplit[2]}/${dateSplit[1]}/${dateSplit[0]}`
        }

        return date;
    },

    formatDateToSave: (date) => {
        if (date) {
            if (typeof date === 'object') {
                return date.toJSON().split('T')[0];
            }

            return date.split(" ")[0];
        }

        return null;
    },

    formatCpf: (value) => {
        if (value === '' || value === null || value === undefined) {
            return '';
        }

        value = value.replace(/[^\d]/g, "");
        return value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
    },

    validateCpf: (cpf) => {
        if (typeof cpf !== 'string') return false
        cpf = cpf.replace(/[^\d]+/g, '')
        if (cpf.length !== 11 || !!cpf.match(/(\d)\1{10}/)) return false
        cpf = cpf.split('')
        const validator = cpf
            .filter((digit, index, array) => index >= array.length - 2 && digit)
            .map( el => +el )
        const toValidate = pop => cpf
            .filter((digit, index, array) => index < array.length - pop && digit)
            .map(el => +el)
        const rest = (count, pop) => (toValidate(pop)
            .reduce((soma, el, i) => soma + el * (count - i), 0) * 10) % 11 % 10
        return !(rest(10,2) !== validator[0] || rest(11,1) !== validator[1])
    },

    sortColumns: (columns, order) => {
        return columns.sort((a, b) => {
            const indexA = order.indexOf(a.field);
            const indexB = order.indexOf(b.field);

            const adjustedIndexA = indexA === -1 ? Infinity : indexA;
            const adjustedIndexB = indexB === -1 ? Infinity : indexB;

            return adjustedIndexA - adjustedIndexB;
        });
    },

    nullLastDateStringComparator: (valueA, valueB, nodeA, nodeB, isInverted) => {
        const formatDate = (givenDate) => {
            if (!givenDate || typeof givenDate !== 'string' || givenDate.trim() === '') {
                return null;
            }
            const parts = givenDate.split('/');
            const dateObj = new Date(`${parts[2]}-${parts[1]}-${parts[0]}T00:00:00`);
            return isNaN(dateObj.getTime()) ? null : dateObj.getTime();
        };

        const isEmptyForAGGrid = (val) => {
            if (val === null || val === undefined) return true;

            if (typeof val === 'string' && (val.trim() === '' || val.trim() === '[]')) return true;

            if (Array.isArray(val) && val.length === 0) return true;

            if (typeof val === 'object' && !Array.isArray(val)) {
                return Object.keys(val).length === 0;
            }

            if (typeof val === 'number' && isNaN(val)) return true;

            return false;
        }

        const firstTime = formatDate(valueA);
        const secondTime = formatDate(valueB);

        if (firstTime === secondTime) {
            return 0;
        } else if (isEmptyForAGGrid(firstTime)) {
            return isInverted ? -1 : 1;
        } else if (isEmptyForAGGrid(secondTime)) {
            return isInverted ? 1 : -1;
        } else {
            if (firstTime === secondTime) return 0;
            if (typeof firstTime === 'string' && typeof secondTime === 'string') {
                return firstTime.localeCompare(secondTime);
            }
            return (firstTime > secondTime) ? 1 : -1;
        }
    },

    exportCsv: (newArray) => {
        const csvDatas = [];

        const formatValue = (value) => {
            if (value === null || value === undefined) {
                return '';
            }
            let strValue = String(value);

            if (strValue.includes(';') || strValue.includes('\n') || strValue.includes('"')) {
                strValue = strValue.replace(/"/g, '""');
                return `"${strValue}"`;
            }

            return strValue;
        };
        const csvMaker = (data) => Object.values(data).map(formatValue).join(';');

        const headers = Object.keys(newArray[0]);

        csvDatas.push(headers.map(formatValue).join(';'));

        newArray.map((item) => csvDatas.push(csvMaker(item)));

        const blob = new Blob(['\uFEFF' + csvDatas.join('\n')], { type: 'text/csv;charset=utf-8' });

        const url = window.URL.createObjectURL(blob);

        window.open(url);
        window.URL.revokeObjectURL(url);
    },

    nullLastComparator: (a, b, nodeA, nodeB, isInverted) => {
        const isEmptyForAGGrid = (val) => {
            if (val === null || val === undefined) return true;

            if (typeof val === 'string' && (val.trim() === '' || val.trim() === '[]')) return true;

            if (Array.isArray(val) && val.length === 0) return true;

            if (typeof val === 'object' && !Array.isArray(val)) {
                return Object.keys(val).length === 0;
            }

            if (typeof val === 'number' && isNaN(val)) return true;

            return false;
        }

        if (a === b) {
            return 0;
        } else if (isEmptyForAGGrid(a)) {
            return isInverted ? -1 : 1;
        } else if (isEmptyForAGGrid(b)) {
            return isInverted ? 1 : -1;
        } else {
            if (a === b) return 0;
            if (typeof a === 'string' && typeof b === 'string') {
                return a.localeCompare(b);
            }
            return (a > b) ? 1 : -1;
        }
    },

    hourComparator: (a, b, nodeA, nodeB, isInverted) => {
        const isEmptyForAGGrid = (val) => {
            if (val === null || val === undefined) return true;
            if (typeof val === 'string' && (val.trim() === '' || val.trim() === '[]')) return true;
            if (Array.isArray(val) && val.length === 0) return true;
            if (typeof val === 'object' && !Array.isArray(val)) {
                return Object.keys(val).length === 0;
            }
            if (typeof val === 'number' && isNaN(val)) return true;
            return false;
        }

        if (a === b) {
            return 0;
        } else if (isEmptyForAGGrid(a)) {
            return isInverted ? -1 : 1;
        } else if (isEmptyForAGGrid(b)) {
            return isInverted ? 1 : -1;
        } else {
            const parseHour = (value) => {
                const strValue = String(value);
                return parseFloat(strValue.replace(',', '.'));
            };

            const numA = parseHour(a);
            const numB = parseHour(b);

            if (isNaN(numA) && isNaN(numB)) return 0;
            if (isNaN(numA)) return isInverted ? -1 : 1;
            if (isNaN(numB)) return isInverted ? 1 : -1;

            if (numA === numB) return 0;
            return (numA > numB) ? 1 : -1;
        }
    },

    prepareArrayToList: (value) => {
        let modulePrepared = '';
        try {
            const moduleParsed = JSON.parse(value);
            for (let i = 0; i < moduleParsed.length; i++) {
                if (i === 0) {
                    modulePrepared = moduleParsed[i];
                } else {
                    modulePrepared += ', ' + moduleParsed[i];
                }
            }
        } catch (Error) {
            modulePrepared = value;
        }
        return modulePrepared;
    }
}

export default GeneralUtils;